import A7ABI from '../abi/Avatar721.json'
import BaseByName from './BaseByName';
export default class Avatar721 extends BaseByName {
    constructor(provider) {
        super(provider, A7ABI, 'Avatar721');
    }

    async listMyNFT(addr) {
        return await this.contract.methods.listMyNFT(addr).call({from:addr});
    }
}
